/**
 * @param {object} state
 * @param {string} error
 */
const setError = (state, error) => {
  state.error = error
}

/**
 * These mutations are for UI state only.
 *
 * @type {object}
 */
const mutations = {
  setError
}

export default mutations
